import React from "react"
import Layout from "@layouts/Layout"
import { Container, Col, Row, Button } from "react-bootstrap"
import Image from "gatsby-image"
import { graphql } from "gatsby"
import htmlExists from "../utils/htmlExists"
import Text from "../utils/text"
import SEO from "../components/SEO"
import Featured from "@components/Featured"

const about = ({
  data: {
    allContentfulRow: { rows },
  },
}) => {
  return (
    <Layout>
      <SEO title="About" />
      {rows.map(
        (
          {
            supertitle,
            title,
            description,
            backgroundColor,
            imageRight,
            image: { fluid },
          },
          index
        ) => (
          <section className={`py-5 py-md-6 bg-${backgroundColor}`} key={index}>
            <Container>
              <Row className="align-items-center">
                <Col lg={6} className={!imageRight && "order-1"}>
                  <span className="font-weight-bold text-secondary text-uppercase">
                    {supertitle}
                  </span>
                  <h1>
                    <u>{title}</u>
                  </h1>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: htmlExists(description),
                    }}
                  />
                </Col>
                <Col lg={6} className="px-md-6">
                  <Image fluid={fluid} className="mb-4" />
                </Col>
              </Row>
            </Container>
          </section>
        )
      )}
      <Featured />
    </Layout>
  )
}

export const query = graphql`
  {
    allContentfulRow(sort: { order: ASC, fields: [order] }) {
      rows: nodes {
        image {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
        backgroundColor
        description {
          childMarkdownRemark {
            html
          }
        }
        title
        supertitle
        imageRight
      }
    }
  }
`

export default about
